import { getConfig } from "@components/Config";

const isExternalInvestorPortalEnabled = (organizationId?: string): boolean => {
  const enabledOrgIds = getConfig("EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS") as string[];
  const hasOrganizationId = Boolean(organizationId);

  if (!hasOrganizationId) {
    return false;
  }

  return enabledOrgIds.includes(organizationId);
};

export default isExternalInvestorPortalEnabled;
